import { render, staticRenderFns } from "./AppImageCropper.vue?vue&type=template&id=0b419258&scoped=true&"
import script from "./AppImageCropper.vue?vue&type=script&lang=js&"
export * from "./AppImageCropper.vue?vue&type=script&lang=js&"
import style0 from "./AppImageCropper.vue?vue&type=style&index=0&id=0b419258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b419258",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
